import React, { memo } from "react"

import { Modal, Paragraph, TrackingEvent } from "@ncs/web-legos"

import { useShopContext } from "~/contexts"
import { useAnalytics } from "~/hooks/useAnalytics"

export interface RemoveFromCartModalProps {
	isOpen: boolean
	onClose: () => void
	partId: string | null
	partTitle: string | null
}

export const RemoveFromCartModal: React.FC<RemoveFromCartModalProps> = memo(
	({ isOpen, onClose, partId, partTitle }) => {
		const [, shopDispatch] = useShopContext()
		const { trackEvent } = useAnalytics()

		if (!partId) {
			return null
		}

		const onRemove = () => {
			if (partId) {
				shopDispatch({
					type: "remove from cart",
					payload: partId,
				})
			}
			onClose()
			trackEvent(TrackingEvent.REMOVE_ITEM)
		}

		return (
			<Modal
				isOpen={isOpen}
				onClose={onClose}
				rightButtons={{
					buttonText: "Remove",
					variant: "secondary-cta",
					onClick: onRemove,
				}}
			>
				<Paragraph>
					Remove <strong>{partTitle}</strong> from your cart?
				</Paragraph>
			</Modal>
		)
	}
)
